import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Tabber from 'components/Tabber';
import EntityHistory from 'components/EntityHistory';
import MediaEditor from 'components/MediaEditor';
import HotelEditMain from 'components/HotelEditMain';
import HotelEditRooms from 'components/HotelEditRooms';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import TableSorting from 'components/TableSorting';

import { HotelEditTabs_hotel$key } from '__generated__/HotelEditTabs_hotel.graphql';
import { HotelEditTabs_data$key } from '__generated__/HotelEditTabs_data.graphql';

type Props = {
  hotel: HotelEditTabs_hotel$key;
  data: HotelEditTabs_data$key;
};

const HotelEditTabs: FC<Props> = props => {
  const hotel = useFragment(
    graphql`
      fragment HotelEditTabs_hotel on Hotel {
        media(first: 2147483647) {
          pageInfo {
            total
          }
        }

        rooms(first: $first, after: $after, search: $search, sort: $sort) {
          pageInfo {
            total
          }
        }

        ...HotelEditMain_hotel
        ...MediaEditor_mediable
        ...EntityHistory_entity
        ...HotelEditRooms_hotel
      }
    `,
    props.hotel
  );

  const data = useFragment(
    graphql`
      fragment HotelEditTabs_data on Query {
        ...HotelEditMain_data
      }
    `,
    props.data
  );

  return (
    <Tabber
      tabs={[
        {
          title: 'Bendra informacija',
          hash: 'main',
          component: <HotelEditMain hotel={hotel} data={data} />,
        },
        {
          title: `Nuotraukos [${hotel.media?.pageInfo.total ?? 0}]`,
          hash: 'media',
          component: <MediaEditor mediable={hotel} />,
        },
        {
          title: `Kambariai [${hotel.rooms?.pageInfo.total ?? 0}]`,
          hash: 'rooms',
          component: (
            <TableSorting>
              <Search>
                <Pagination>
                  <HotelEditRooms hotel={hotel} />
                </Pagination>
              </Search>
            </TableSorting>
          ),
        },
        {
          title: 'Istorija',
          hash: 'history',
          component: <EntityHistory entity={hotel} />,
        },
      ]}
    />
  );
};

export default HotelEditTabs;
